import { atom } from 'jotai'

// 工作台审批、工单数量
export const workbenchCountAtom = atom<number>(0)
